<div class="ips-flex-loading-box mb-4">
    <div class="content">
        <span class="d-block" translate>PAYPAL_POSTBACK</span><br />
        <div class="pb-3" *ngIf="error" translate>{{errorMessage}}</div>
        <div class="pb-3" *ngIf="error"><strong>Result Code:</strong> {{paymentInfo.Result}}</div>
        <div *ngIf="error"><strong>Response Message:</strong> {{paymentInfo.Message}}</div>
    </div>
</div>

